import { render, staticRenderFns } from "./ConsumeList.vue?vue&type=template&id=f97c22e0&scoped=true&"
import script from "./ConsumeList.vue?vue&type=script&lang=js&"
export * from "./ConsumeList.vue?vue&type=script&lang=js&"
import style0 from "./ConsumeList.vue?vue&type=style&index=0&id=f97c22e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97c22e0",
  null
  
)

export default component.exports